/**
 * <ry-tag>
 *
 * Removable pill/tag component.
 *
 * Usage:
 * <ry-tag>Default</ry-tag>
 * <ry-tag variant="primary" removable>Removable</ry-tag>
 * <ry-tag size="sm" removable data-value="js">JavaScript</ry-tag>
 *
 * JS uses data-ry-target for queries, CSS uses classes for styling.
 */

import { RyElement } from '../core/ry-element.js';
import { getIcon } from '../core/ry-icons.js';

export class RyTag extends RyElement {
  setup(): void {
    this.#transformMarkup();
  }

  #transformMarkup(): void {
    if (this.$('[data-ry-target="label"]')) return;

    const text = this.textContent?.trim() ?? '';
    const removable = this.hasAttribute('removable');

    this.innerHTML = `<span data-ry-target="label" class="ry-tag__label">${text}</span>${
      removable
        ? `<button data-ry-target="remove" class="ry-tag__remove" aria-label="Remove" type="button">${getIcon('close')}</button>`
        : ''
    }`;

    if (removable) {
      const btn = this.$<HTMLButtonElement>('[data-ry-target="remove"]');
      if (btn) {
        this.on(btn, 'click', (e: MouseEvent) => {
          e.stopPropagation();
          this.emit('remove', {
            value: this.dataset.value ?? '',
            label: text
          });
          this.remove();
        });
      }
    }
  }

  get label(): string {
    return this.$('[data-ry-target="label"]')?.textContent?.trim() ?? '';
  }
}

customElements.define('ry-tag', RyTag);
